import React from 'react'
import createReactClass from 'create-react-class'
import FlywheelCancelled from './flywheel/flywheelcancelled'
import CloudwaysCancelled from './cloudways/cloudwayscancelled'
import WPEngineCancelled from './wpengine/wpenginecancelled'
import WPCOMCancelled from './wpcom/wpcomcancelled'
import MgCancelled from './mg/mgcancelled'

const Cancelled =  createReactClass({
	render() {
		const { migrate, history } = this.props
		switch (migrate.get('origin')) {
		case ORIGIN.FLYWHEEL:
			return <FlywheelCancelled migrate={migrate} />
		case ORIGIN.CLOUDWAYS:
			return <CloudwaysCancelled migrate={migrate} />
		case ORIGIN.WPENGINE:
			return <WPEngineCancelled migrate={migrate} />
		case ORIGIN.AUTOMATTIC:
			return <WPCOMCancelled migrate={migrate} history={history} />
		default:
			return <MgCancelled migrate={migrate} history={history} />
		}
	}
})

export default Cancelled
